import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppHttpClient } from './app-http-client.service';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  constructor(private http: AppHttpClient) {}

  submitFeedback(appId: string, rating: number, comment?: string): Observable<any> {
    return this.http.post('feedback', { appId, rating, comment });
  }
}
